import React from 'react';
import { Skeleton, Switch } from '@mui/material';
import Box from '@mui/material/Box';
import { observer } from 'mobx-react';

import { useStore } from 'utils/hooks/store';

import { NotificationSettingsSwitchProps } from './types';

const NotificationSettingsSwitch: React.FunctionComponent<NotificationSettingsSwitchProps> = ({ value, onChange }) => {
  const {
    notificationSettings: { notificationsSettings, isUpdating, isLoading },
  } = useStore();

  if (isLoading) {
    return (
      <Box sx={{ padding: '12px' }} data-testid="notification-settings-switch-loader">
        <Skeleton variant="rounded" width={34} height={14} />
      </Box>
    );
  }
  return (
    <Switch
      checked={value}
      value={value}
      onChange={(_, checked) => {
        onChange(checked);
      }}
      disabled={notificationsSettings === undefined || isUpdating}
      data-testid="notification-settings-switch"
    />
  );
};

export default observer(NotificationSettingsSwitch);
